import {Component, OnDestroy, OnInit, inject} from '@angular/core';
import {AccessService} from '../../services/access.service';
import {DataService} from "../../services/data.service";
import {environment} from "../../../environments/environment";
import {Right} from "../interfaces";
import {RouterLink, RouterLinkActive} from '@angular/router';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {NgIf} from '@angular/common';

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrl: './navigation.component.scss',
    imports: [RouterLink, RouterLinkActive, TooltipModule, NgIf]
})
export class NavigationComponent implements OnInit, OnDestroy {

    accessService = inject(AccessService);
    private dataService = inject(DataService);

    readonly Right = Right;
    currentApplicationVersion = environment.appVersion;

    onlineNames = '';
    online = [];
    interval;

    ngOnInit(): void {
        this.interval = setInterval(() => {
            this.getOnlineUsers();
        }, 60000);
        this.getOnlineUsers();
    }

    ngOnDestroy(): void {
        if (this.interval) clearInterval(this.interval);
    }

    getOnlineUsers(): void {
        this.dataService.request('User/getOnline').subscribe(response => {
            this.online = response.online;
            this.onlineNames = response.online.map(function (element) {
                return element.name;
            }).join("<br/>");
        });
    }
}
